<template>
  <div class="min-vh">
    <CRow class="no-gutters px-3 px-sm-0">
      <b-col xl="4" class="text-center text-sm-left mb-0">
        <h1 class="mb-0 header-main text-uppercase">LIVE {{ id > 0 ? 'EDIT' : 'CREATE'}}</h1>
      </b-col>
      <b-col xl="8" class="text-center text-sm-left mb-0">
        <div class="w-100 action-div"></div>
      </b-col>
    </CRow>

    <div class="mt-3 bg-white-border p-3 main-theme text-body" v-if="live">
      <b-row>
        <b-col>
          <InputText
            v-model="live.name"
            name="live.name"
            textFloat="Name"
            placeholder="Name"
            type="text"
          />
        </b-col>
        <b-col>
          <InputSelect
            title="Select Facebook Post"
            name="live.postId"
            v-model="live.postId"
            :options="posts"
            valueField="id"
            textField="message"
            @onDataChange="(val) => live.postId = val"
          />
        </b-col>
      </b-row>

      <div
        class="d-flex justify-content-between align-items-center p-3 border"
        style="background-color:#e2dff3"
      >
        <span class="unit-font text-break">การตั้งค่าคีย์เวิร์ด</span>
          <b-link class="text-link" @click="addReply">+เพิ่มคีย์เวิร์ดการตอบกลับ</b-link>
      </div>
      <div
        v-for="(reply, replyIndex) in live.replyList"
        :key="replyIndex"
        class="mb-3 bg-white p-3 border"
      >
        <b-row>
          <b-col>
            <InputText
              v-model="reply.keywordGroupName"
              name="reply.keywordGroupName"
              textFloat="Keyword Group Name"
              placeholder="Keyword Group Name"
              type="text"
              isRequired
              :isValidate="$v.live.replyList.$each.$iter[replyIndex].keywordGroupName.$error"
              :v="$v.live.replyList.$each.$iter[replyIndex].keywordGroupName"
            />
          </b-col>
          <b-col>
            <div class="text-right">
              <span class="text-break">
                <b-button
                  variant="link"
                  class="text-danger py-0 pr-0"
                  @click="removeReply(replyIndex)"
                >
                  <font-awesome-icon icon="trash-alt" class="text-danger" title="Delete" />
                </b-button>
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                <strong class="mb-0 pb-0">Keyword<span class="text-danger">*</span></strong>
              </template>
              <b-form-tags
                input-id="tags-pills"
                v-model="reply.keyword"
                tag-variant="secondary"
                tag-pills
                size="lg"
                separator=" "
                placeholder=""
              ></b-form-tags>
              <div v-if="$v.live.replyList.$each.$iter[replyIndex].keyword && $v.live.replyList.$each.$iter[replyIndex].keyword.$error">
                <span class="text-error" v-if="$v.live.replyList.$each.$iter[replyIndex].keyword.required == false">กรุณากรอกข้อมูล</span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="
              reply.channelTypeList.find(
                (channelType) => channelType.replyChannelId == 1
              )
            "
          >
            <!-- {{
              reply.channelTypeList.find(
                (channelType) => channelType.replyChannelId == 1
              )
            }} -->
            <div
              class="bg-light p-3 rounded text-black"
              v-if="
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 1
                ) != null
              "
            >
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 1
                        ).status
                      "
                    >
                      Comment Type
                    </b-form-checkbox>
                  </b-form-group>
                </span>
                <span class="text-break">
                  <b-form-select
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).replyTypeId
                    "
                    @change="
                      onChangeChannelReplyTypeId(
                        $event,
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 1
                        )
                      )
                    "
                  >
                    <b-form-select-option :value="1">Text</b-form-select-option>
                    <b-form-select-option :value="2"
                      >Image(s)</b-form-select-option
                    >
                  </b-form-select>
                </span>
              </div>
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 1
                  ).replyTypeId == 1
                "
              >
                <b-form-group
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 1
                    ).textImage[0]
                  "
                >
                  <b-form-textarea
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).textImage[0].text
                    "
                    placeholder="Text Here..."
                    rows="3"
                  ></b-form-textarea>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 1
                        ).textImage[0].text
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </b-form-group>
              </div>

              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 1
                  ).replyTypeId == 2
                "
              >
                <ImageUpload
                  :textImages="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 1
                    ).textImage
                  "
                />
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 1
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).textImage.length > 0
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >
              </div>
            </div>
          </b-col>

          <b-col
            v-if="
              reply.channelTypeList.find(
                (channelType) => channelType.replyChannelId == 2
              )
            "
          >
            <div class="bg-light text-black  p-3 rounded">
              <!-- {{
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 2
                )
              }} -->
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).status
                      "
                      style="color:black"
                    >
                      Direct Message
                    </b-form-checkbox>
                  </b-form-group>
                </span>
                <span class="text-break">
                  <b-form-select
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).replyTypeId
                    "
                    @change="
                      onChangeChannelReplyTypeId(
                        $event,
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        )
                      )
                    "
                  >
                    <b-form-select-option
                      v-for="(messageReplyType,
                      messageReplyTypeIndex) in messageReplyTypes"
                      :key="messageReplyTypeIndex"
                      :value="messageReplyType.id"
                      >{{ messageReplyType.name }}</b-form-select-option
                    >
                  </b-form-select>
                </span>
              </div>
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 1
                "
              >
                <b-form-group
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                >
                  <b-form-textarea
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0].text
                    "
                    placeholder="Text Here..."
                    rows="3"
                  ></b-form-textarea>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).textImage[0].text
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </b-form-group>
              </div>
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 2
                "
              >
                <ImageUpload
                  :textImages="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage
                  "
                />
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage.length > 0
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >
              </div>
              <!-- typetextImage -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 4
                "
              >
                <div
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                >
                  <TextImageInput
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0]
                    "
                    :textImage="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0]
                    "
                  />
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).textImage[0].text |
                          !reply.channelTypeList.find(
                            (channelType) => channelType.replyChannelId == 2
                          ).textImage[0].imageUrl
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </div>
              </div>
              <!-- typebutton -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 3
                "
              >
                <b-form-textarea
                  v-model="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0].text
                  "
                  placeholder="Text Here..."
                  rows="3"
                ></b-form-textarea>
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0].text
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >
                <div
                  class="mt-3"
                  style="cursor:pointer;
                       color:blue;  
                       text-decoration:underline;"
                  @click="
                    addButton(
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      )
                    )
                  "
                >
                  +เพิ่มปุ่ม
                </div>
                <div
                  v-for="(button, buttonIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).buttons"
                  :key="buttonIndex"
                >
                  <TextButtonInput
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status !== undefined
                    "
                    :isValidated="isValidated"
                    :button="button"
                    :index="buttonIndex"
                    :status="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status
                    "
                    :buttons="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).buttons
                    "
                  />
                </div>
              </div>
              <!-- typeflex -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 5
                "
              >
                <TextImageInput
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                  :textImage="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                />
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0].text |
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).textImage[0].imageUrl
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >

                <div class="mt-3">
                  <span
                    style="cursor:pointer;
                       color:blue;  
                       text-decoration:underline;"
                    @click="
                      addButton(
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        )
                      )
                    "
                    >+เพิ่มปุ่ม</span
                  >
                </div>
                <div
                  v-for="(button, buttonIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).buttons"
                  :key="buttonIndex"
                >
                  <TextButtonInput
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status !== undefined
                    "
                    :isValidated="isValidated"
                    :button="button"
                    :index="buttonIndex"
                    :status="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status
                    "
                    :buttons="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).buttons
                    "
                  />
                </div>
              </div>
              <!-- typeproduct -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 6
                "
              >
                <b-button
                  variant="outline-primary"
                  @click="$bvModal.show('bv-modal-product')"
                  >Add product</b-button
                >
                <div>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products.length > 0
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </div>
                <b-modal id="bv-modal-product" size="xl" hide-footer>
                  <template #modal-title>
                    Select Product
                  </template>
                  <div class="d-block text-center">
                    <SelectProduct
                      :confirmProduct="selectProduct"
                      :products="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products
                      "
                    />
                  </div>
                </b-modal>
                <div
                  class="bg-white rounded my-3 p-3"
                  v-for="(product, productIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).products"
                  :key="productIndex"
                >
                  <div
                    class="d-flex justify-content-between align-items-center p-3"
                  >
                    <img
                      :src="product.imageUrl"
                      :alt="product.name"
                      width="80px"
                    />
                    <span class="unit-font text-break"
                      >product {{ product.name }}
                    </span>
                    <span class="text-break">
                      <b-button
                        variant="link"
                        class="text-danger px-1 py-0"
                        @click="
                          removeProduct(
                            reply.channelTypeList.find(
                              (channelType) => channelType.replyChannelId == 2
                            ).products,
                            productIndex
                          )
                        "
                      >
                        <font-awesome-icon icon="trash-alt" class="text-danger" title="Delete" />
                      </b-button>
                    </span>
                  </div>
                </div>
              </div>
              <!-- typeaddtocart -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 7
                "
              >
                <b-button
                  variant="outline-primary"
                  @click="$bvModal.show('bv-modal-product')"
                  >Add product</b-button
                >
                <div>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products.length > 0
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </div>
                <b-modal id="bv-modal-product" size="xl" hide-footer>
                  <template #modal-title>
                    Select Product
                  </template>
                  <div class="d-block text-center">
                    <SelectProduct
                      :confirmProduct="selectProduct"
                      :products="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products
                      "
                    />
                  </div>
                </b-modal>
                <div
                  class="bg-white rounded my-3 p-3"
                  v-for="(product, productIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).products"
                  :key="productIndex"
                >
                  <div
                    class="d-flex justify-content-between align-items-center p-3"
                  >
                    <img
                      :src="product.imageUrl"
                      :alt="product.name"
                      width="80px"
                    />
                    <span class="unit-font text-break"
                      >product {{ product.name }}
                    </span>
                    <span class="text-break">
                      <b-button
                        variant="link"
                        class="text-danger px-1 py-0"
                        @click="
                          removeProduct(
                            reply.channelTypeList.find(
                              (channelType) => channelType.replyChannelId == 2
                            ).products,
                            productIndex
                          )
                        "
                      >
                        <font-awesome-icon icon="trash-alt" class="text-danger" title="Delete" />
                      </b-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <small
          class="text-danger"
          v-if="
            isValidated &&
              !(
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 1
                ).status |
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 2
                ).status
              )
          "
          >กรุณากรอกข้อมูลให้ถูกต้อง</small
        >
      </div>
      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/live">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5"
              >CANCEL</b-button
            >
          </router-link>
        </b-col>
        <b-col md="6" class="text-sm-right">
          <button
            type="button"
            @click="save()"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalGoToSetting ref="ModalGoToSetting" />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import ImageUpload from "./Component/ImageUpload";
import TextImageInput from "./Component/TextImage";
import TextButtonInput from "./Component/TextButton";
import SelectProduct from "./Component/SelectProduct";
import ModalGoToSetting from "./Component/ModalGoToSetting.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "LiveEdit",
  components: {
    ModalAlertConfirm,
    ImageUpload,
    TextImageInput,
    TextButtonInput,
    SelectProduct,
    InputText,
    InputSelect,
    ModalGoToSetting
  },
  validations() {
    return {
      live: {
        replyList:{
          $each: {
            keywordGroupName: { required },
            keyword: { required },
          }
        }
      }
    };
  },
  data() {
    return {
      id: this.$route.params.id,
      postTypeId: this.$route.params.postTypeId,
      commentReplyTypes: [],
      messageReplyTypes: [],
      live: null,
      pageId: null,
      posts: [],
      isValidated: false,
    };
  },
  async created() {
    await this.$store.commit("UPDATE_MAIN_LOADING", true);
    await this.checkLoginPage();
    if (!this.isLoginPage) {
      this.$refs.ModalGoToSetting.show();
      return;
    }
    this.getCommentReplyTypes();
    this.getMessageReplyTypes();
    if (this.id == 0) {
      this.setDefault();
    } else {
      await this.getDetail();
      this.setDefault();
    }
    this.getFacebooklist();
    await this.$store.commit("UPDATE_MAIN_LOADING", false);
  },
  methods: {
    async getFacebooklist() {
      await this.axios
        .post(`${this.$baseUrl}/livePost/Facebooklist`, {
          postId: this.live.postId,
          postTypeId: this.postTypeId,
          paging: {
            pageNo: 1,
            perPage: 9999,
          },
        })
        .then((data) => {
          console.log("get facebook list", data);
          if (data.result == 1) {
            let list = [{id: 0, message: "Please Select"}];
            this.posts = list.concat(data.detail.posts);
          }
        });
    },
    async checkLoginPage() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/checkLoginPage`)
        .then((data) => {
          console.log("check login page", data);
          if (data.result == 1) {
            this.isLoginPage = data.detail != 0;
            if (this.isLoginPage) {
              this.pageId = data.detail.pageId;
            }
          }
        });
    },
    getProducts: async function(products, productIds) {
      await this.axios
        .post(`${this.$baseUrl}/product/list`, {
          search: "",
          pageNo: 1,
          perPage: productIds.length,
          productIdList: productIds,
          Categories: [],
        })
        .then((data) => {
          console.log("get products", data);
          if (data.result == 1) {
            data.detail.dataList.forEach((product) => {
              product["productId"] = product.id;
            });
            products.length = 0;
            products.push(...data.detail.dataList);
          }
        });
    },
    async save() {
      this.$v.$touch();
      if (this.$v.live.$error) return;

      this.isValidated = true;
      if (!this.validate()) {
        alert("กรุณากรอกข้อมูลให้ถูกต้อง");
        return;
      }
      var body = JSON.parse(JSON.stringify(this.live));
      body.replyList = body.replyList.map((reply) => {
        reply.channelTypeList = reply.channelTypeList.filter(
          (channelType) => channelType.status
        );
        return reply;
      });
      if (this.live.id == 0) {
        this.live.postCreatedTime = this.posts.find(
          (item) => item.id == this.live.postId
        ).createdTime;
      }
      await this.$store.commit("UPDATE_MAIN_LOADING", true);

      await this.axios
        .post(`${this.$baseUrl}/livePost/save`, body)
        .then(async (data) => {
          console.log("save", data);
          await this.$store.commit("UPDATE_MAIN_LOADING", false);

          if (data.result == 1) {
            this.$router.push({ path: `/live` }).catch(() => {});
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message }); 
          }
        });
    },
    validate() {
      var isHaveError = this.live.replyList.some((reply) => {
        if (
          reply.channelTypeList.every(
            (channelType) => channelType.status == false
          )
        ) {
          return true;
        }

        var commentChannelType = reply.channelTypeList.find(
          (channelType) => channelType.replyChannelId == 1
        );
        if (commentChannelType) {
          if (commentChannelType.status) {
            switch (commentChannelType.replyTypeId) {
              case 1:
                // text
                if (!commentChannelType.textImage[0].text) {
                  return true;
                }
                break;
              case 2:
                // image
                if (!commentChannelType.textImage.length > 0) {
                  return true;
                }
                break;
            }
          }
        }

        var messageChannelType = reply.channelTypeList.find(
          (channelType) => channelType.replyChannelId == 2
        );

        if (messageChannelType.status) {
          switch (messageChannelType.replyTypeId) {
            case 1:
              // text
              if (!messageChannelType.textImage[0].text) {
                return true;
              }
              break;
            case 2:
              // image
              if (!messageChannelType.textImage.length > 0) {
                return true;
              }
              break;
            case 4:
              // text image
              if (!messageChannelType.textImage[0].text) {
                return true;
              }
              if (!messageChannelType.textImage[0].imageUrl) {
                return true;
              }
              break;
            case 3:
              // text button
              if (
                messageChannelType.buttons.some((button) => {
                  if (!button.sortOrder) {
                    return true;
                  }
                  if (!button.label) {
                    return true;
                  }
                  if (!button.data) {
                    return true;
                  }
                  return false;
                })
              ) {
                return true;
              }
              break;
            case 5:
              // flex
              if (!messageChannelType.textImage[0].text) {
                return true;
              }
              if (!messageChannelType.textImage[0].imageUrl) {
                return true;
              }
              if (
                messageChannelType.buttons.some((button) => {
                  if (!button.sortOrder) {
                    return true;
                  }
                  if (!button.label) {
                    return true;
                  }
                  if (!button.data) {
                    return true;
                  }
                  return false;
                })
              ) {
                return true;
              }
              break;
            case 6:
              // product
              if (!messageChannelType.products.length > 0) {
                return true;
              }
            case 7:
              // add to cart
              if (!messageChannelType.products.length > 0) {
                return true;
              }
              break;
            default:
            // code block
          }
        }
        return false;
      });
      console.log("isHaveError", isHaveError);
      return !isHaveError;
    },
    getDetail: async function() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/${this.id}`)
        .then((data) => {
          console.log("get live detail", data);
          if (data.result == 1) {
            this.live = data.detail;
          }
        });
    },
    removeReply(replyIndex) {
      this.live.replyList.splice(replyIndex, 1);
    },
    removeProduct(products, productIndex) {
      products.splice(productIndex, 1);
    },
    getCommentReplyTypes: function() {
      this.axios
        .get(`${this.$baseUrl}/masterdata/LiveReplyType/1`)
        .then((data) => {
          if (data.result == 1) {
            this.commentReplyTypes = data.detail;
          }
        });
    },
    getMessageReplyTypes: function() {
      this.axios
        .get(`${this.$baseUrl}/masterdata/LiveReplyType/2`)
        .then((data) => {
          if (data.result == 1) {
            this.messageReplyTypes = data.detail;
          }
        });
    },
    addDefaultReplyChannel(reply, replyChannelId) {
      reply.channelTypeList.push({
        id: 0,
        status: false,
        replyTypeId: 1,
        replyChannelId: replyChannelId,
        textImage: [{ text: null, imageUrl: null }],
        products: [],
        buttons: [],
      });
    },
    addReply() {
      var reply = {
        replyId: 0,
        limit: 0,
        keywordGroupName: "",
        keyword: [],
        channelTypeList: [],
      };
      this.addDefaultReplyChannel(reply, 1);
      this.addDefaultReplyChannel(reply, 2);
      this.live.replyList.push(reply);
    },
    setDefault() {
      if (this.live) {
        this.setDefaultReply();
      } else {
        this.live = {
          id: 0,
          pageId: this.pageId,
          postTypeId: this.postTypeId,
          postId: 0,
          postName: "",
          postImageUrl: "",
          name: "",
          statusId: 0,
          replyList: [],
        };
        this.addReply();
      }
      console.log("live", this.live);
    },
    setDefaultReply() {
      this.live.replyList.forEach((reply) => {
        var commentChannel = reply.channelTypeList.find(
          (channel) => channel.replyChannelId == 1
        );
        if (commentChannel != null) {
          commentChannel["status"] = true;
        } else {
          this.addDefaultReplyChannel(reply, 1);
        }
        var messageChannel = reply.channelTypeList.find(
          (channel) => channel.replyChannelId == 2
        );
        if (messageChannel) {
          messageChannel["status"] = true;
          if ([6, 7].includes(messageChannel.replyTypeId)) {
            console.log(messageChannel.products);
            var productIds = messageChannel.products.map(
              (product) => product.productId
            );
            this.getProducts(messageChannel.products, productIds);
          }
        } else {
          this.addDefaultReplyChannel(reply, 2);
        }
      });
    },
    selectProduct(products, selectedProducts) {
      this.getProducts(products, selectedProducts);
      this.$bvModal.hide("bv-modal-product");
    },
    onChangeChannelReplyTypeId(event, channel) {
      channel.textImage = [];
      channel.products = [];
      channel.buttons = [];
      console.log(channel);
      if ([1, 3, 4, 5].includes(event)) {
        channel.textImage.push({
          text: null,
          imageUrl: null,
        });
      }
      if ([3, 5].includes(event)) {
        this.addButton(channel);
      }
    },
    addButton(channel) {
      channel.buttons.push({
        label: null,
        data: null,
        actionTypeId: 1,
        buttonTypeId: 1,
        sortOrder: 1,
      });
    },
  },
};
</script>

<style></style>
